import { FC, useEffect, useState } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import { ROUTES } from '../../utils'
import { useAppSelector } from '../../redux'
import { LoginView, RegisterView } from '..'
import { StyledAuthView } from '.'

const AuthView: FC = () => {
  const history = useHistory()
  const { _id } = useAppSelector((state) => state.user)

  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const onChange = (key: string, value: string) => {
    switch (key) {
      case 'username':
        return setUsername(value)
      case 'email':
        return setEmail(value)
      case 'password':
        return setPassword(value)
    }
  }

  useEffect(() => {
    if (!!_id) {
      history.push(ROUTES.home)
    }
  }, [_id])

  return (
    <StyledAuthView>
      <Switch>
        <Route path={ROUTES.auth.login} exact>
          <LoginView
            formData={{ email, password }}
            onChange={(key, value) => onChange(key, value)}
          />
        </Route>
        <Route path={ROUTES.auth.register} exact>
          <RegisterView
            formData={{ username, email, password }}
            onChange={(key, value) => onChange(key, value)}
          />
        </Route>
      </Switch>
    </StyledAuthView>
  )
}

export default AuthView
